import { Link } from "react-router-dom";

const SIZES = {
  sm: { box: "w-7 h-7", text: "text-base", tagline: "text-[10px]" },
  md: { box: "w-10 h-10", text: "text-xl", tagline: "text-[11px]" },
  lg: { box: "w-12 h-12", text: "text-2xl", tagline: "text-xs" },
  xl: { box: "w-16 h-16", text: "text-3xl", tagline: "text-sm" },
};

/**
 * Brand mark — uses /brand/hrbo-logo.png at native resolution. We intentionally
 * never upscale beyond the source. The PNG renders crisply at 28–64px.
 */
export default function Brand({ size = "md", to = "/", showTagline = false, dark = false, testid = "brand-link" }) {
  const s = SIZES[size] || SIZES.md;
  const content = (
    <div className="flex items-center gap-2.5">
      <img
        src="/brand/hrbo-logo.png"
        alt="HRBo logo"
        width={64}
        height={64}
        className={`${s.box} rounded-full object-cover shrink-0`}
        style={{ imageRendering: "auto" }}
        loading="eager"
        decoding="async"
      />
      <div className="leading-tight">
        <div className={`font-bold tracking-tight ${s.text} ${dark ? "text-white" : "text-slate-950"}`} style={{ fontFamily: "Outfit, sans-serif" }}>
          HRBo
        </div>
        {showTagline && (
          <div className={`${s.tagline} uppercase tracking-[0.18em] mt-0.5 ${dark ? "text-slate-300" : "text-slate-500"}`}>
            Seamless Attendance · Precise Payroll
          </div>
        )}
      </div>
    </div>
  );

  if (!to) return <div data-testid={testid}>{content}</div>;
  return <Link to={to} data-testid={testid}>{content}</Link>;
}
